export default function WheelchairIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 19 18">
            <path d="M4.5 11.02a3.86 3.86 0 0 0 7.34 1.7l-.41-.76h-.76A2.5 2.5 0 1 1 7.23 8.8V7.32a3.86 3.86 0 0 0-2.73 3.7Z"/>
            <path d="M14.12 14.08c-.49 0-.64-.04-.71-.07a.5.5 0 0 1-.25-.22l-1.35-2.64H8.55a.47.47 0 0 1-.47-.48V5.6a1.47 1.47 0 0 1-.45-1.04 1.46 1.46 0 1 1 1.86 1.4V7.4h2.3c.27 0 .48.2.48.47v.34c0 .27-.2.48-.48.48H9.48v1.18h2.82c.14 0 .28.07.36.18.13.14.43.64 1.48 2.7h.63c.27 0 .48.22.48.48v.36c0 .26-.21.47-.48.47-.27.03-.48.03-.65.03Z"/>
        </svg>
    )
}


